import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service from './provisionService';

const useMutation_ProvisionLogin = (onError?: (error: ServiceError) => void) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('provision.errors.workflowAuth') });
  return useMutation({
    mutationFn: async (...args: Parameters<typeof service.login>) => {
      try {
        return await service.login(...args);
      } catch (e) {
        throw parseError(e);
      }
    },
    onError,
  });
};

const useProvisionAuth = {
  mutate: {
    login: useMutation_ProvisionLogin,
  }
};

export { useProvisionAuth };
